export const questionGroupsHeaderUtil = (questions) => {
  const { 0: firstQuestion, length, [length - 1]: lastQuestion } = questions;
  const leftNum = firstQuestion.no;
  const rightNum = lastQuestion.no + (lastQuestion.questionCount - 1);

  if (leftNum === rightNum) {
    return `Question ${leftNum}`;
  }
  return `Question ${leftNum} - ${rightNum}`;
};
